import React, { useState } from 'react';
import { FormDetailModel } from 'types/FormTypes';
import { FormContext } from './FormDrawerContext';

export const FormProvider: React.FC = ({ children }) => {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [totalSteps, setTotalSteps] = useState<number>(0);
  const [nextDisabled, setNextDisabled] = useState<boolean>(false);
  const [backDisabled, setBackDisabled] = useState<boolean>(false);
  const [formData, setFormData] = useState<FormDetailModel[]>([]);
  const [startScreen, setStartScreen] = useState<boolean>(false);
  const [endScreen, setEndScreen] = useState<boolean>(false);
  const [fileUploading, setFileUploading] = useState<boolean>(false);

  return (
    <FormContext.Provider
      value={{
        currentStep,
        setCurrentStep,
        backDisabled,
        setBackDisabled,
        nextDisabled,
        setNextDisabled,
        totalSteps,
        setTotalSteps,
        formData,
        setFormData,
        startScreen,
        setStartScreen,
        endScreen,
        setEndScreen,
        fileUploading,
        setFileUploading,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};
